module.exports = __webpack_public_path__ + "img/flow_blue.98a1fca1.svg";